import {Box, Button, Stack} from '@mui/material';
import React from 'react';
import {
	AlertModal,
	IFrameModal,
	MainFooter,
	MainHeader,
	PageWrapperLayout,
	SendMessageModal,
} from 'presentation/components';
import {StyledGrid} from 'presentation/components/Grid';
import {useHostName} from 'presentation/hooks';
import {translations} from 'presentation/translations-new';
import {ChatsModal} from './components/ChatsModal';
import {ContactChannels} from './components/ContactChannels';
import {useHelp} from './hooks/useHelp';

import {HelpSection} from './components/HelpSection';
import {SupportCard} from './components/SupportCard';
import {useHelpExternalLinks} from './hooks/useHelpExternalLinks';
import {HelpPageTaggingEnum} from 'main/analytics/gaTagsEnum';

const {title, SOS, contactUs, sendYourMessage, faq, ourAddresses} =
	translations['pt-br'].privateFlow.help;
const {agreementText} = translations['pt-br'].commons;
const {errorModal} = translations['pt-br'].privateFlow.help.SOS;

export function Help() {
	const {dataHostNameState} = useHostName();
	const womenChannel = SOS[dataHostNameState.product];
	const {
		canShowCanalDelas,
		canShowFaq,
		isTalkToUsFeatureFlagEnabled,
		openChatsModalState,
		openInformativeModalState,
		handleCloseChatsModal,
		handleBack,
		handleOpenChatsModal,
		handleGoFormSendMessage,
		handleCloseInformativeModal,
		handleGoToAddresses,
	} = useHelp();

	const {
		faqUrl,
		isFaqLoading,
		isWomenChannelLoading,
		isFaqIframeOpen,
		isExternalLinkError,
		handleOpenFaq,
		handleOpenWomenChannel,
		handleCloseFaqIframe,
		handleCloseExternalLinkError,
	} = useHelpExternalLinks();

	const sendMessageCard = (
		<SupportCard
			dataTagId={HelpPageTaggingEnum.CLICK_MANDE_SUA_MENSAGEM_AJUDA}
			icon="mail-default"
			title={sendYourMessage.cardTitle}
			description={
				isTalkToUsFeatureFlagEnabled
					? sendYourMessage.cardDescription
					: sendYourMessage.cardDescriptionOld
			}
			onClick={handleGoFormSendMessage}
		/>
	);

	return (
		<PageWrapperLayout title={title}>
			<MainHeader
				title={title}
				handleBack={handleBack}
				dataTagId={{
					backButtonRoute: HelpPageTaggingEnum.CLICK_VOLTAR_AJUDA,
				}}
				hideProfileMenu
			/>
			<StyledGrid.Root p={{xs: 2, sm: 4}} spacing={3}>
				<StyledGrid.Item sm={12} md={12} lg={8}>
					<Stack gap={3}>
						{canShowFaq ? (
							<HelpSection title={faq.title}>
								<SupportCard
									dataTagId={HelpPageTaggingEnum.CLICK_DUVIDAS_FREQUENTES_AJUDA}
									icon="menu-book-filled"
									title={faq.cardTitle}
									description={faq.cardDescription}
									onClick={handleOpenFaq}
									isDisabled={isFaqLoading}
									isLoading={isFaqLoading}
								/>
							</HelpSection>
						) : null}
						<HelpSection title={contactUs.title}>
							{!isTalkToUsFeatureFlagEnabled ? sendMessageCard : null}
							<SupportCard
								dataTagId={HelpPageTaggingEnum.CLICK_POSSO_AJUDAR_AJUDA}
								icon="chat-filled"
								title={contactUs.cardTitle}
								description={contactUs.cardDescription}
								onClick={handleOpenChatsModal}
							/>
							{isTalkToUsFeatureFlagEnabled ? sendMessageCard : null}
							<SupportCard
								icon="map"
								title={ourAddresses.title}
								description={ourAddresses.cardDescription}
								onClick={handleGoToAddresses}
							/>
						</HelpSection>
						{canShowCanalDelas ? (
							<HelpSection title={womenChannel.title}>
								<SupportCard
									dataTagId={HelpPageTaggingEnum.CLICK_CANAL_DELAS_AJUDA}
									icon="campaign-filled"
									buttonIcon="ben-export"
									title={womenChannel.cardTitle}
									description={womenChannel.cardDescription}
									onClick={handleOpenWomenChannel}
									isDisabled={isWomenChannelLoading}
									isLoading={isWomenChannelLoading}
								/>
							</HelpSection>
						) : null}
					</Stack>
				</StyledGrid.Item>

				<StyledGrid.Item sm={12} md={12} lg={4}>
					<ContactChannels />
				</StyledGrid.Item>
			</StyledGrid.Root>
			<Box mt="auto">
				<MainFooter />
			</Box>
			<ChatsModal open={openChatsModalState} onClose={handleCloseChatsModal} />

			<SendMessageModal
				open={openInformativeModalState}
				onBack={handleCloseInformativeModal}
			/>

			<AlertModal
				headerTitle={errorModal.headerTitle}
				title={errorModal.title}
				description={errorModal.description}
				open={isExternalLinkError}
				onClose={handleCloseExternalLinkError}
				variant="info"
				footerContent={
					<Button
						onClick={handleCloseExternalLinkError}
						variant="contained"
						size="large"
						fullWidth>
						{agreementText}
					</Button>
				}
			/>
			<IFrameModal
				openIframe={isFaqIframeOpen}
				setOpenIframe={handleCloseFaqIframe}
				title={faq.cardTitle}
				url={faqUrl}
			/>
		</PageWrapperLayout>
	);
}
